import { CHROME_PAGE_MATCHING_MAX_HTML_LENGTH } from '../../../types/chrome-page-matching'
export const PAGE_CONTEXT_TYPE = 'residesk:chrome-page-context'
export const PAGE_CONTEXT_REQUEST = 'residesk:chrome-page-context-request'

const isValidHtml = (html) =>
  typeof html === 'string' && html.length <= CHROME_PAGE_MATCHING_MAX_HTML_LENGTH

export const parseChromePageContext = (data) => {
  if (data?.type !== PAGE_CONTEXT_TYPE || data.version !== 1 || Object.keys(data).length !== 3) return null
  const c = data.context
  if (!c || typeof c !== 'object') return null
  if (c.status === 'available' && Object.keys(c).length === 1) return c
  if (typeof c.requestId !== 'string' || !/^[a-zA-Z0-9-]{1,80}$/.test(c.requestId)) return null
  if (c.status === 'unavailable' && Object.keys(c).length === 2) return c
  const hasHtml = Object.prototype.hasOwnProperty.call(c, 'html')
  if (hasHtml && !isValidHtml(c.html)) return null
  if (c.status !== 'page' || Object.keys(c).length !== (hasHtml ? 5 : 4) || typeof c.text !== 'string'
    || c.text.length > 32000 || typeof c.complete !== 'boolean') return null
  return c
}
